(() => {
  const init = () => {
    document.querySelectorAll('.nopa-ugc__track video').forEach((v) => {
      if (v.dataset.nopaObserved) return;
      v.dataset.nopaObserved = '1';
      const io = new IntersectionObserver((entries) => {
        entries.forEach((e) => { e.intersectionRatio >= 0.6 ? v.play().catch(() => {}) : v.pause(); });
      }, { threshold: [0, 0.6] });
      io.observe(v);
    });
  };
  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
